// extracted by mini-css-extract-plugin
module.exports = {"toggleLayout":"styles_toggleLayout__HII4v","togglePrivate":"styles_togglePrivate__lTR9J"};